import { useContext } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow, TableFooter, Typography } from '@mui/material';
import { orderContext } from '../OrderContext';
import { CircleLoader, DetailsPageHeader } from 'components';
import Moment from 'react-moment';

let Activities = () => {
    let service = useContext(orderContext);

    return (
        <DetailsPageHeader sectionName='Activities'>
            {service.isLoading && <CircleLoader />}
            {service.isLoading === false &&
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Date</TableCell>
                            <TableCell>Source</TableCell>
                            <TableCell>Details</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {service.order.activities
                            .map((activity, index) =>
                                <TableRow hover key={index}>
                                    <TableCell style={{ whiteSpace: 'nowrap' }}>
                                        {activity.date &&
                                            <Moment date={activity.date} format="LLL" />
                                        }
                                        {!activity.date &&
                                            '-'
                                        }
                                    </TableCell>
                                    <TableCell>{activity.source}</TableCell>
                                    <TableCell>{activity.detail}</TableCell>
                                </TableRow>
                            )}
                    </TableBody>
                    {(!service.order.activities || service.order.activities.length === 0) &&
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={3}>
                                    <Typography variant="subtitle2">No activities found</Typography>
                                </TableCell>
                            </TableRow>
                        </TableFooter>
                    }
                </Table>
            }
        </DetailsPageHeader>
    );
}

export default Activities;